import { PawPrint, BadgeCheck } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const cities = [
  "Kraków", "Legnica", "Żagań", "Kielce",
  "Piotrków Tryb.", "Stargard", "Chełm", "Milanówek",
  "Rzezawa", "Hajnówka", "Sokółka", "Szumowo",
];

export const InstagramStory12Gradient = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Gradient overlay - trendy neon/gradient effect */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, rgba(78,138,110,0.75) 0%, rgba(45,90,61,0.6) 50%, rgba(100,180,140,0.7) 100%)",
          mixBlendMode: "multiply",
          zIndex: 1,
        }}
      />

      {/* Glow effects */}
      <div
        style={{
          position: "absolute",
          top: "15%",
          left: "-10%",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(107,175,141,0.4) 0%, transparent 70%)",
          filter: "blur(40px)",
          zIndex: 2,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "20%",
          right: "-15%",
          width: "600px",
          height: "600px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(78,138,110,0.5) 0%, transparent 70%)",
          filter: "blur(50px)",
          zIndex: 2,
        }}
      />

      {/* Safe zone content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 80px 280px",
          position: "relative",
          zIndex: 3,
        }}
      >
        {/* Header with big number */}
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <div
            style={{
              fontSize: "220px",
              fontWeight: 800,
              color: "#FFFFFF",
              lineHeight: 0.85,
              textShadow: "0 0 80px rgba(255,255,255,0.4), 0 8px 32px rgba(0,0,0,0.3)",
            }}
          >
            12
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "14px",
              marginTop: "-8px",
            }}
          >
            <BadgeCheck style={{ width: "44px", height: "44px", color: "#FFFFFF" }} />
            <span
              style={{
                fontSize: "46px",
                fontWeight: 700,
                color: "#FFFFFF",
                textShadow: "0 2px 16px rgba(0,0,0,0.3)",
              }}
            >
              zweryfikowanych
            </span>
          </div>
        </div>

        {/* Cities grid - glassmorphism style */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "center",
            alignContent: "center",
            padding: "0 20px",
          }}
        >
          {cities.map((city, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(10px)",
                borderRadius: "50px",
                padding: "18px 32px",
                border: "1px solid rgba(255,255,255,0.25)",
                boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
              }}
            >
              <span
                style={{
                  fontSize: "28px",
                  fontWeight: 700,
                  color: "#FFFFFF",
                  textShadow: "0 1px 8px rgba(0,0,0,0.2)",
                }}
              >
                📍 {city}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "24px",
              padding: "24px 48px",
              display: "inline-block",
              marginBottom: "24px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            }}
          >
            <p style={{ fontSize: "32px", fontWeight: 700, color: "#2D5A3D", margin: 0 }}>
              Sprawdź ich potrzeby 💚
            </p>
          </div>

          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "rgba(255,255,255,0.9)",
                borderRadius: "14px",
                width: "48px",
                height: "48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "28px", height: "28px", color: "#4E8A6E" }} />
            </div>
            <span
              style={{
                fontSize: "32px",
                fontWeight: 800,
                color: "#FFFFFF",
                textShadow: "0 2px 12px rgba(0,0,0,0.3)",
              }}
            >
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
